<template>
  <section class="document-form sme-container__info sme-container__info-document">
    <div class="box">
      <div class="table">
        <div class="th font-14" >Documents</div>
        <div class="form-item tr">
          <span>Renewal Notice or 3rd Party Quotation</span>
          <file-container
            is-show-detail
            is-viewer
            :fileData="renewal_files" />
        </div>
        <div class="form-item tr">
          <span>Business Registration Certificate</span>
          <file-container
            is-show-detail
            is-viewer
            :fileData="br_files" />
        </div>
        <div
          class="form-item tr">
          <span>Latest 3 months Contribution Record</span>
          <div>
            <file-container
              v-for="(item, index) in mpf_files"
              :key="index"
              is-show-detail
              class="mg-b-10"
              is-viewer
              :fileData="item"
            />
          </div>
        </div>
        <div
          class="form-item tr">
          <span>Insurer Application Form</span>
          <div>
            <file-container
              is-show-detail
              is-viewer
              :fileData="prop_pdf_path"
            />
          </div>
        </div>
        <div
          class="form-item tr">
          <span>Insurer Official Quotation</span>
          <div>
            <file-container
              is-show-detail
              is-viewer
              :fileData="insurer_quotation_path"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'SMEDocumentInfo',
  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  computed:{
    upload_document(){
      let {upload_document}  = this.formData||{}
      return upload_document
    },
    br_files(){
      let {br_file} = this.formData||{}
      return br_file||{}
    },
    renewal_files(){
      let {renew_file} = this.formData||{}
      return renew_file||{}
    },
    mpf_files(){
      let {mpf_files=[]} = this.formData||{}
      return mpf_files
    },
    prop_pdf_path(){
      let {prop_pdf_file} = this.formData||{}
      return prop_pdf_file||{}
    },
    insurer_quotation_path(){
      let {insurer_quotation_file} = this.formData||{}
      return insurer_quotation_file||{}
    },
  }
}
</script>
<style lang="scss" scoped>
@import "../../quoting/sme/info";
.document-table{
  .tr:last-child{
    border-bottom-left-radius: 0px!important;
    border-bottom-right-radius: 0px!important;
  }
}

</style>
